import { GET_REPORT_LIST_ERROR,GET_REPORT_LIST_POST_ERROR,GET_GROUP_LIST_ERROR, GET_GROUP_LIST_POST_ERROR, GET_GROUP_LIST_SUCCESS, GET_REPORT_LIST_SUCCESS,GET_REPORT_CSV_LIST_SUCCESS,GET_REPORT_SHAPE_LIST_SUCCESS } from "../actions/types";

export default (state = {
    error: null,
    results: [],
    groups:[],
    key:'',
    csv: '',
    shape:'',
}, action) => {
    switch (action.type) {
        case GET_REPORT_LIST_SUCCESS:
            return {
                ...state,
                results: action.payload,  
                loading:false,
                key:action.key,
                success: true,
                isSnackbarError: false,
                isSwitchSnackbarOn: true,
                ErrorMessage: "Retrieve success",
            }
            break;
            case GET_REPORT_CSV_LIST_SUCCESS:
                return {
                    ...state,
                    csv:action.payload,  
                    loading:false,
                    success: true,
                    key:action.key,
                    isSnackbarError: false,
                    isSwitchSnackbarOn: true,
                    ErrorMessage: "Download success",
                }
                
            case GET_REPORT_SHAPE_LIST_SUCCESS:
                return {
                    ...state,
                    shape:action.payload,  
                    loading:false,
                    success: true,
                    key:action.key,
                    isSnackbarError: false,
                    isSwitchSnackbarOn: true,
                    ErrorMessage: "Download success",
                }
                
            case GET_GROUP_LIST_SUCCESS:
                return {
                    ...state,
                    groups:action.payload,  
                    loading:false,
                    success: true,
                    key:action.key,
                    isSnackbarError: false,
                    isSwitchSnackbarOn: true,
                    ErrorMessage: "Group Retrieved",
                }
                
            case GET_GROUP_LIST_ERROR:
                return {
                    ...state,
                    error: state.error,
                    loading:false,
                    success: false,
                    key:action.key,
                    isSnackbarError: true,
                    isSwitchSnackbarOn: true,
                    ErrorMessage: "RETRIEVE GROUP LIST ERROR OR NULL | "+ action.payload,
                }
                
            case GET_GROUP_LIST_POST_ERROR:
                return {
                    ...state,
                    error: state.error,
                    loading:false,
                    success: false,
                    key:action.key,
                    isSnackbarError: true,
                    isSwitchSnackbarOn: true,
                    ErrorMessage: "RETRIEVE GROUP LIST NETWORK ERROR OR NULL | "+ action.payload,
                }
            case GET_REPORT_LIST_ERROR:
            return {
                ...state,
                error: state.error,
                loading:false,
                success: false,
                key:action.key,
                isSnackbarError: true,
                isSwitchSnackbarOn: true,
                ErrorMessage: "RETRIEVE ERROR OR NULL | "+ action.payload,
            }
            break;
        case GET_REPORT_LIST_POST_ERROR:
            return {
                ...state, 
                error: state.error,
                loading:false,
                success: false,
                key:action.key,
                isSnackbarError: true,
                isSwitchSnackbarOn: true,
                ErrorMessage: "RETRIEVE POST ERROR | CONTACT NETWORK ADMINISTRATOR",
            }
            break;
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/reportListReducer.js